import React, { FC, ReactElement } from 'react';
import { Field } from 'formik';

import PageHeader from '@buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/pageHeader';
import RadioField from '@buyside/components/presentation/Form/Field/RadioField/radioField';
import {
  WizardSubmitButton,
  WizardPage
} from '@buyside/components/presentation/Form/Wizard/Wizard';
import { investorStatusSchema } from '@buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/validations';

import styles from '@buyside/components/presentation/AccreditedInvestorProfilePage/Pages/pageStyles.scss';

const radioOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

const AccreditedInvestorStatus: FC<{
  isLoading: boolean;
  validationSchema: typeof investorStatusSchema;
}> = ({ isLoading, validationSchema }): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      <PageHeader subHeader="Investor Status" />
      <div>
        <div className={styles.field}>
          <label className={styles.label}>
            My individual net worth is greater than 1 million USD (excluding primary residence).
          </label>
          <Field component={RadioField} name="netWorthReq" options={radioOptions} inColumn />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>
            In the last two years, my annual income (gross) was greater than 200,000 USD
            individually or 300,000 USD jointly. I expect the same income level in the current year.
          </label>
          <Field component={RadioField} name="incomeReq" options={radioOptions} inColumn />
        </div>
      </div>
      <div className={styles.actionsContainer}>
        <WizardSubmitButton submitText="Continue" isLoading={isLoading} />
      </div>
    </WizardPage>
  );
};

export default AccreditedInvestorStatus;
